angular.module('impactx.rfx').controller('RFXThreadViewBuyerCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'RFXThreadSaveService',
    'ToolbarService',
    'ToastService',
    'BackService',
    '$redirect',
    RFXThreadViewBuyerCtrl
]);

function RFXThreadViewBuyerCtrl($scope, dataGen, $routeParams, TranslationService, RFXThreadSaveService, ToolbarService,
                                ToastService, BackService, $redirect) {
    $scope.threadId = $routeParams.id;
    var wasPrivate = false;

    dataGen.getData($scope, {
        id: $scope.threadId,
        rfqhId: $routeParams.rfqhId,
        isSupport: $routeParams.isSupport
    }, "/rfx/thread/view/buyer").then(function () {
        $scope.setButtons();
    });

    $scope.save = function () {
        return RFXThreadSaveService.saveData($scope).then(function () {
            RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, false)
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    $scope.setButtons = function () {
        wasPrivate = !$scope.data.isPublic.value;
        $scope.buttonDefinition = [
            {
                label: TranslationService.get("save"),
                action: $scope.save,
                type: 'validation',
                params: {form: $scope.dialogData},
                condition: canSave
            },
            {
                label: $scope.trns.startSupport,
                action: startSupport,
                type: 'dialogaction',
                condition: canStartSupport,
                process: 'RFXRequestSupportView'
            },
            {
                label: $scope.trns.finishSupport,
                action: finishSupport,
                type: 'dialogaction',
                condition: canFinishSupport,
                process: 'RFXRequestSupportView'
            }
        ];

        ToolbarService.setButtons($scope.buttonDefinition);
    };

    function canFinishSupport() {
        return $scope.data.canFinishSupport;
    }

    function canStartSupport() {
        return $scope.data.canStartSupport;
    }

    function finishSupport() {
        return dataGen.postAsForm({}, {rfqhId: $routeParams.rfqhId}, "/rfx/support/request/finishsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.redirectTo(null, "/rfxrequestsupportlist");
        });
    }

    function startSupport() {
        return dataGen.postAsForm({}, {rfqhId: $routeParams.rfqhId}, "/rfx/support/request/startsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.reload();
        });
    }

    $scope.onCommentAdded = function () {
        if ($scope.threadId > 0) {
            RFXThreadSaveService.saveData($scope).then(function () {
                RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, false)
            });
            ToastService.openStandardToast($scope.trns.commentSaved);
        }
    };

    $scope.onAttachmentAdded = function () {
        if ($scope.threadId > 0) {
            RFXThreadSaveService.saveData($scope).then(function () {
                RFXThreadSaveService.notifyUsers($scope.data.id, $scope.threadId == 0, false)
            });
            ToastService.openStandardToast($scope.trns.attachmentSaved);
        }
    };

    function canSave() {
        return wasPrivate && $scope.data.isPublic.value;
    }
}